import { GET_ALL_STATIC_PAGES_RESPONSE_SUCCESS } from "./actionTypes";
import { combineReducers } from "redux";

const Index = (state = [], action) => {
  const { payload } = action;
  switch (action.type) {
    case GET_ALL_STATIC_PAGES_RESPONSE_SUCCESS:
      return payload;

    default:
      return state;
  }
};

const staticPages = combineReducers({
  Index,
});

export default staticPages;
